import React, {memo} from "react";
import {useParams} from "react-router-dom";

import {NETWORK_ID} from "web3/chains";

import {PriceHistorySection} from "components/molecules";
import {Accordion} from "components/atoms";

const BazaarCurrentItemPriceHistory = () => {
    const {network, token_id} = useParams()

    return (
        <Accordion
            open={true}
            icon="price"
            title="priceHistory"
        >
            <PriceHistorySection tokenId={token_id} chainId={NETWORK_ID[network]}/>
        </Accordion>
    )
}

export default memo(BazaarCurrentItemPriceHistory)